import { IProductOverviewPriceStatus } from '../ProductOverview';
import { overviewColors } from '../ProductOverviewChart/ProductChartUtils';
import React from 'react';

interface IProductOverviewSummeryProps {
  priceData: IProductOverviewPriceStatus;
}
export const ProductOverviewSummary: React.FC<IProductOverviewSummeryProps> = ({ priceData }) => {
  const dataLines: { title: string; value: string; color: string }[] = [
    { title: 'Date', value: priceData.focusDate, color: '#FFFF' },
    { title: 'Product price', value: `$${priceData.productPrice}`, color: overviewColors.product },
    { title: 'Raw material cost', value: `$${priceData.materialPrice}`, color: overviewColors.material },
    { title: 'Future raw material cost', value: `$${priceData.futurePrice}`, color: overviewColors.future },
  ];

  return (
    <>
      <div className="">
        <h6 className="text-red text-lg">Limit bars</h6>
        <div className="flex flex-col gap-4 max-w-24">
          <div className="flex flex-col space-y-1">
            <p className="text-sm text-secondary_text">High</p>
            <div className="w-full">
              <input
                type="number"
                value="222.5"
                onChange={() => {}}
                className="text-base  border-1 rounded border-gray-450 px-[0.5rem] py-[0.1rem] w-full"
                placeholder="high limit"
              ></input>
            </div>
          </div>
          <div className="flex flex-col space-y-1">
            <p className="text-sm text-secondary_text">Low</p>
            <div className="w-full">
              <input
                type="number"
                value="105.0"
                onChange={() => {}}
                className="text-base  border-1 rounded border-gray-450 px-[0.5rem] py-[0.1rem] w-full"
                placeholder="low limit"
              ></input>
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-2">
        <h6 className="text-red  text-lg"></h6>
        <div className="space-y-4 border-b-2 pb-2 m-0 border-gray-100">
          {dataLines.map(({ value, title, color: borderLeftColor }, index) => (
            <div className="border-l-4 space-y-2 ps-1.5 -ms-2" style={{ borderLeftColor }} key={index}>
              <p className="text-sm text-secondary_text ">{title}</p>
              <p className="text-lg">{value}</p>
            </div>
          ))}
        </div>
        <div className="flex gap-8">
          <div>
            <p className="text-sm text-secondary_text ">Margin</p>
            <p className="text-lg text-purple-300">
              ${(priceData.productPrice - priceData.materialPrice).toLocaleString()}
            </p>
          </div>
          <div>
            <p className="text-sm text-secondary_text ">Future margin</p>
            <p className="text-lg text-green-400">
              ${(priceData.productPrice - priceData.futurePrice)?.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
